import axios from './axios_api';
import * as url from './api.constant';
export const loadVidmList = async payload => {
  return await axios.post(url.URL_VIDM_LIST, payload);
};
export const loadSearchBcDocs = async payload => {
  return await axios.post('/document/query', payload);
};
